export class BeneficiariosAsistenciaMedicaEntity{
    constructor(
         public Codigo?:number,
        public  CodigoCliente ?:number,
        public  CodigoCiudad ?:number,
        public  CodigoProducto ?:number,
        public  CodigoAsistencia ?:number,
        public  Nombre ?:string,
        public  ApellidoMaterno ?:string,
        public  ApellidoPaterno?:string,
        public  Relacion ?:string,
        public  CodRelacion ?:number,
        public  FechaNacimiento?:Date,
        public  Estado ?:number
    ){}
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/masivos/datosGenerales/entities/beneficiarios_asistencia_medica_entity.ts